<template>
    <div v-if="loading" style="z-index: 0" class="bg-white text-center p-20 text-gray-600">
        <button type="button" class="inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-gray-500 hover:bg-gray-400 transition ease-in-out duration-150 cursor-not-allowed" disabled="">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Wczytuję...
        </button>
    </div>

    <div v-if="!loading" class="bg-gray-900">
        <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:px-8 lg:py-24">
            <div class="space-y-12">
                <div class="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
                    <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">Kuchnia "u Chowańca"</h2>
                    <p class="text-xl text-gray-300">Dzisiaj w ofercie:</p>
                </div>


                <ul role="list" class="space-y-4 sm:grid sm:grid-cols-2 sm:gap-6 sm:space-y-0 lg:grid-cols-3 lg:gap-8">
                    <li v-for="product in products" :key="product.name"
                        class="rounded-lg bg-gray-800 py-10 px-6 text-center xl:px-10 xl:text-left">
                        <div class="space-y-6 xl:space-y-10">
                            <img class="mx-auto h-40 w-40 rounded-full xl:h-56 xl:w-56" :src="product.image_url" alt=""/>
                            <div class="space-y-2 xl:flex xl:items-center xl:justify-between">
                                <div class="space-y-1 text-lg font-medium leading-6">
                                    <h3 class="text-white">{{ product.name }}</h3>
                                    <p v-if="product.active" class="text-green-500">DOSTĘPNE</p>
                                    <p v-else class="text-red-500">NA ZAMÓWIENIE</p>
                                </div>

                                <ul role="list" class="flex justify-center space-x-5">
                                    <li>
                                        <span class="text-white text-xl font-bold">{{ product.price }}</span>
                                    </li>
                                    <!--                                    <li>-->
                                    <!--                                        <span class="text-white">{{product.promoPrice}}</span>-->
                                    <!--                                    </li>-->
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
let products;
export default {
    name: "GastronomyPage",
    data: () => ({
        products,
        loading: true,
    }),

    methods: {
        async getProducts() {
            await fetch('https://cloudpanel.pl/api/uchowanca/gastronomy')
                .then(response => response.json())
                .then(result => {
                    this.products = result.products;
                    console.log(this.products)
                    this.loading=false;
                });

        },
    },

    created() {
        this.getProducts();
    },
    mounted() {
        console.log('mounted gastro')
    }

}

</script>

<style scoped>

</style>
